<template>
    <div>
        <div class="dc-btn-block"
            v-if="!isNews()">
            <div class="dc-btn"
                :class="{'dc-btn-active': strActiveTab === 'detail'}"
                @click="clickChangeTab('detail')">
                <div class="dc-inner-btn">{{lbl.detail.detail}}</div>
            </div>
            <div class="dc-btn"
                :class="{'dc-btn-active': strActiveTab === 'condition'}"
                @click="clickChangeTab('condition')">
                <div class="dc-inner-btn">{{lbl.detail.condition}}</div>
            </div>
        </div>
        <div class="dc-content"
            v-if="!isNews()">
            <div class="dc-content-item"
                v-show="strActiveTab === 'detail'"
                v-html="strDetail"></div>
            <div class="dc-content-item"
                v-show="strActiveTab === 'condition'"
                v-html="strCondition"></div>
        </div>
        <div class="dc-content"
            v-if="isNews()">
            <div class="dc-content-item"
                v-html="strDetail"></div>
        </div>
  </div>
</template>
<script>

import Vue from 'vue';
import Util from '@/helper/Utility.js';
/**
 * @event clickChangeTab
 */
export default {
    name: "CampaignDetailAndCondtition",
    props: {
        lbl: Object,
        userType: String,
        campaign: Object
    },
    data: function() {
        return {
            strActiveTab: "detail", //detail, condition
            strDetail: "",
            strCondition: "",
            campaignType: Vue.CampaignType,
        };
    },
    created: function() {
        this.strDetail = Util.newLineToBr(this.campaign.detail);
        this.strCondition = Util.newLineToBr(this.campaign.condition);
    },
    methods: {
        clickChangeTab: function(strTab) {
            this.strActiveTab = strTab;
        },
        isNews: function() {
            return this.campaign.type === this.campaignType.Event ||
                   this.campaign.type === this.campaignType.News;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/common.scss";
.dc-btn-block {
    @extend %display-flex;

    .dc-btn {
        width: 50%;
        flex: 0 0 50%;
        padding: 10px 0;
        color: $gray-A0A0A0;
        font-size: 1.5rem;
        font-weight: 400;
        text-align: center;

        &.dc-btn-active {
            color: $green-00987F;
            border-bottom: 2px solid $green-00987F;
        }
    }
}

.dc-content {
    width: 100%;
    padding: 16px 0;

    .dc-content-item {
        padding-bottom: 60px;
        color: $gray-575757;
        font-size: 1.5rem;
        word-break: break-word;
        line-height: normal;
    }
}
</style>
